import { humanize } from '../../../ui/Badge';
import { Markdown } from '../../../ui/Markdown';
import { Link } from 'react-router';
import { ActorName, Card, KeyValue } from '../../../ui/misc';
import { Timestamp } from '../../../ui/Timestamp';
import type { AttemptDetail } from '../types';

export function BindingDetails({ a }: { a: AttemptDetail }) {
  const b = a.binding;
  return (
    <>
      <Card title="Approved binding (immutable)" tight>
        <KeyValue
          items={[
            ['Environment', b.environmentName],
            ...(b.deliveryMethod
              ? [['Delivery method', humanize(b.deliveryMethod)] as [string, React.ReactNode]]
              : []),
            [
              'Revision',
              <span key="r" className="mono small">
                {b.sourceRevision ?? b.rollbackRevision}
              </span>,
            ],
            ['Artifact', b.artifactDigest ? <span className="mono small">{b.artifactDigest}</span> : '—'],
            ['Executor', <ActorName key="e" actor={a.executor} />],
            [
              'Approval',
              a.approval ? (
                <Link to={`/approvals/${a.approval.displayId}`}>{a.approval.displayId}</Link>
              ) : (
                '—'
              ),
            ],
            ['Approved by', a.approval?.decidedBy ? <ActorName actor={a.approval.decidedBy} /> : '—'],
            ['Registered', <Timestamp key="g" value={a.registeredAt} />],
            ['Last progress', <Timestamp key="p" value={a.lastProgressAt} />],
          ]}
        />
      </Card>
      {b.deliveryMethod === 'manual' && (
        <Card title="Manual deployment plan">
          <Markdown>{b.deploymentPlan ?? ''}</Markdown>
          <span className="small">
            Deploy this approved binding using your authorized access, then report the actual outcome and
            every required check.
          </span>
        </Card>
      )}
      {b.tickets && (
        <Card title="Tickets" tight>
          <span className="small mono">{b.tickets.map((t) => t.key).join(', ')}</span>
        </Card>
      )}
      {b.affectedTickets && (
        <Card title="Affected tickets" tight>
          <span className="small mono">{b.affectedTickets.map((t) => t.key).join(', ') || 'None'}</span>
        </Card>
      )}
    </>
  );
}
